if (!customElements.get('pf-anniversary-timer')) {
  customElements.define('pf-anniversary-timer', class extends HTMLElement {
    connectedCallback() {
      let scope = this.parentElement;
      let price;
      for (let depth = 0; scope && depth < 5; depth++, scope = scope.parentElement) {
        price = scope.querySelector('.jnh-price, .pwt-price, .plaid-price, .price');
        if (price) break;
      }
      if (!this.hasAttribute('data-keep-position') && price && this.previousElementSibling !== price) {
        price.insertAdjacentElement('afterend', this);
        return;
      }
      this.end = Date.parse(this.dataset.end);
      this.clock = this.querySelector('[role="timer"]');
      this.update();
      if (!this.hidden) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const seconds = Math.floor((this.end - Date.now()) / 1000);
      if (!Number.isFinite(seconds) || seconds <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        return;
      }
      const values = { hours: Math.floor(seconds / 3600), minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [key, value] of Object.entries(values)) this.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0');
      this.clock.hidden = false;
      this.hidden = false;
    }
  });
}
